import Styles from './ImageEditor.module.scss'
import { Close, ImageArrows } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons'

interface ImageHotspotPromptViewProps {
  prompt: string
  imageUrls: string[]
  referenceImageUrl?: string | null
  onPromptChange: (value: string) => void
  onRemoveAttachedImage: (index: number) => void
  onPickImage: () => void
  onConfirm: () => void
  onCancel: () => void
  close: () => void
}

export const ImageHotspotPromptView = ({
  prompt,
  imageUrls,
  referenceImageUrl = null,
  onPromptChange,
  onRemoveAttachedImage,
  onPickImage,
  onConfirm,
  onCancel,
  close,
}: ImageHotspotPromptViewProps) => {
  const displayReference = imageUrls[0] ?? referenceImageUrl ?? null
  const hasUserReference = imageUrls.length > 0
  const canSubmit = prompt.trim().length > 0 || imageUrls.length > 0

  return (
    <div className={Styles.imageHotspotPopover}>
      <IconButton
        variant="secondary"
        size="sm"
        icon={Close}
        aria-label="Close"
        onPress={close}
        className={Styles.editTextClose}
      />
      <div className={Styles.imageHotspotBody}>
        <div className={Styles.imageHotspotLabelsRow}>
          <span className={Styles.imageHotspotColumnLabel}>Reference</span>
          <span className={Styles.imageHotspotColumnLabel}>Image Prompt</span>
        </div>
        <div className={Styles.imageHotspotInputsRow}>
          <div className={Styles.imageHotspotReferenceCell}>
            <div className={Styles.imageHotspotThumbWrap}>
              {displayReference ? (
                <img src={displayReference} alt="" className={Styles.imageHotspotThumb} />
              ) : (
                <div className={Styles.imageHotspotThumbPlaceholder} />
              )}
              {hasUserReference && (
                <button
                  type="button"
                  className={Styles.imageHotspotThumbRemove}
                  onClick={() => onRemoveAttachedImage(0)}
                  aria-label="Remove attached reference image"
                >
                  <Trash2 />
                </button>
              )}
              <IconButton
                variant="secondary"
                size="xs"
                icon={ImageArrows}
                aria-label={hasUserReference ? 'Change reference image' : 'Attach image'}
                onPress={onPickImage}
                className={Styles.imageHotspotThumbAttach}
              />
            </div>
          </div>
          <div className={Styles.imageHotspotPromptCell}>
            <textarea
              className={Styles.imageHotspotPromptInput}
              name="imageHotspotPrompt"
              value={prompt}
              onChange={(e) => onPromptChange(e.target.value)}
              rows={3}
              placeholder="Describe the change you want..."
              aria-label="Image prompt"
            />
          </div>
        </div>
      </div>
      <div className={Styles.editTextFooter}>
        <Button variant="tertiary" size="md" className={Styles.editTextBack} onPress={onCancel} aria-label="Cancel">
          Cancel
        </Button>
        <Button
          variant="primary"
          size="md"
          className={Styles.editTextConfirm}
          onPress={onConfirm}
          isDisabled={!canSubmit}
          aria-label="Confirm"
        >
          Confirm
        </Button>
      </div>
    </div>
  )
}
